import { WholesalerContextShape } from '../wholesaler-integration/WholesalerContext'
import React from 'react'
import './WholesalerBrandingContainer.scss'
import Button from '../components/Button'
import { AddToCartArrow } from '../components/icons'
import { BuildConfig } from '../config/BuildConfig'

interface Props {
  wholesalerContext: WholesalerContextShape
  onClickAddToCart: () => void
}


export const WholesalerListSection = ({ wholesalerContext, onClickAddToCart }: Props) => {
  return (
    <div className="WholesalerBrandingContainer">
      <Button buttonStyle="green" onClick={onClickAddToCart}>
        {BuildConfig.brand.copy.Wholesaler.AddToCartButton}
        <img alt="" src={AddToCartArrow} className="arrow" />
      </Button>
      <img
        className="wholesalerLogo"
        alt={`Logo for ${wholesalerContext.brandName}`}
        src={wholesalerContext.brandLogo}
      />
    </div>
  )
}